/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-19 16:27:10 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2023-02-09 14:05:24
 */
import { needCLodop } from "@/util/LodopFuncs";
import request from '@/util/request';
import util from "@/util/util";
import Store from "../pages/home/store/index";
class setTemp {
  // 获取模板列表
   templateList(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.printer.queryTemplateList",
          data: {
            account_id: util.getCookie("account_id"),
            template_platform: "lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
  // 设置默认模板
   setTemplate(self,code) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.printer.setTemplate",
          data: {
            account_id: util.getCookie("account_id"),
            template_code:code,
            template_platform: "lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
   // 测试打印
   testPrint(self,code) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.testPrint",
          data: {
            account_id: util.getCookie("account_id"),
            template_code :code
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
  // 查询偏移量
   queryOffset(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.printer.queryOffset",
          data: {
            account_id: util.getCookie("account_id"),
            template_platform: "lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
  // 设置偏移量
   setOffset(self,type,item) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.printer.setOffset",
          data: {
            account_id: util.getCookie("account_id"),
            offset_x: item.offset_x,
            offset_y: item.offset_y,
            template_code: type,
            template_platform: "lodop"
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
  // 发送链接状态
  //  pcprinter(self,config) {
  //   const connet = config ? 1 : 0; 
  //   const printName = util.getCookie('defult_print');
  //   const lodopStatus = needCLodop();
  //   Store.state.connetStatus = {
  //     WebSocketstatus:config,
  //     name:printName,
  //     lodopStatus
  //   } 
  //   return new Promise((resolve, reject) => {
  //     request
  //       .post(self, {
  //         action: "kdyserver.remote.pcprinter.submit",
  //         data: {
  //           account_id: util.getCookie("account_id"),
  //           pc_printer_name: printName,
  //           login_status:connet, //电脑端已登录0-未登录,1-已登录
  //           print_plugin_status:lodopStatus ? 1 : 0, //打印机插件已安装0-未安装，1-已安装
  //           websocket_status:connet, //websocket通讯正常0-未连接，1-连接正常
  //           pc_printer_default:0 //电脑端默认打印机设置
  //         }
  //       })
  //       .then(res => {
  //         if (res.success) {
  //           if (res.body.result) {
  //             resolve({
  //               success: true,
  //               data: res.body.data
  //             });
  //           } else {
  //             resolve({
  //               success: false,
  //               data: {
  //                 code: res.body.code,
  //                 error: res.body.message || res.body.remark
  //               }
  //             });
  //             self.$message.error(res.body.message || res.body.remark);
  //           }
  //         }
  //       });
  //   });
  //  }
  // 
   changePrinted(self,orders) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.print.printed",
          data: {
            account_id: util.getCookie("account_id"),
            orders: orders  
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
              });
            } else {
              resolve({
                success: false,
              });
            }
          }
        });
    });
   }
   //获取打印机缓存
   getgetPrintName(self) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.remote.pcprinter.getPrintName",
          data:{}
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }  
    //提交打印机缓存
   submitPrintName(self,name) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.remote.pcprinter.submitPrintName",
          data:{
            pc_printer_name:name
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   }
    //根基订单号查电子底单
   queryOrderDeliverySlip(self,order_id) {
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.order.queryOrderDeliverySlip",
          data:{
            account_id: util.getCookie("account_id"),
            order_id: order_id
          }
        })
        .then(res => {
          if (res.success) {
            if (res.body.result) {
              resolve({
                success: true,
                data: res.body.data
              });
            } else {
              resolve({
                success: false,
                data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                }
              });
              self.$message.error(res.body.message || res.body.remark);
            }
          }
        });
    });
   } 
}
export default new setTemp()